import axios from 'axios';
import httpClient from './interceptors';

const walkspan_api = process.env.REACT_APP_API_URL;
const x_api_key = process.env.X_API_KEY;

const connectSuffix = (connector, suffix, url) => {
  if (suffix && suffix !== '') {
    return url += `${connector}suffix=${suffix}`;
  }
  return url;
};

export const login = async (data) => {
  try {
    const finalPayload = data;
    const response = await axios.post(
      `${walkspan_api}/users/login/`,
      finalPayload
    );
    return response;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

export const logout = async () => {
  try {
    const response = await axios.post(`${walkspan_api}/users/logout/`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getProfilebyEmail = async (email) => {
  try {
    const url = `${walkspan_api}/users/get-profile-by-email/?email=${encodeURIComponent(email)}`;
    const response = await httpClient.get(url);

    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

export const getSubscriptionProfile = async (email) => {
  try {
    const url = `${walkspan_api}/subscriptions/profile/?email=${encodeURIComponent(email)}`;
    const response = await httpClient.get(url);

    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

export const usageTracker = async (data, isFree = false) => {
  const url = `${walkspan_api}${isFree ? '/public' : '/subscriptions'}/usage-tracker/`;
  try {
    const response = await httpClient.post(url, data);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    }
    console.error('Error:', error);
  }
};

export const verifyAPIKey = async (token, data) => {
  try {
    const url = `${walkspan_api}/users/verify-api-key/`;
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const forgotPassword = async (data) => {
  try {
    const url = `${walkspan_api}/users/forget-password/`;
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const confirmForgotPassword = async (data) => {
  try {
    const url = `${walkspan_api}/users/reset-password/${data.code}/`;
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const signup = async (data) => {
  try {
    const url = `${walkspan_api}/users/signup/`;
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    console.error(error);
    return error.response
  }
};

export const resendSignup = async (data) => {
  try {
    const url = `${walkspan_api}/users/resend-confirm-code/`;
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const confirmSignup = async (data) => {
  try {
    const url = `${walkspan_api}/users/activate/${data.code}/`;
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    console.error(error);
    return error.response
  }
};

export const getLifeStyleEssentials = async (
  lat,
  lng,
  type,
  area = 'quarter-mile',
  email,
  suffix,
  isFree = false,
) => {
  try {
    const getType = type === 'leisure' ? 'entertainment-fitness' : type;
    let url = `${walkspan_api}${isFree ? '/public' : ''}/lifestyle-essentials/?areatype=${area}&lat=${lat}&lng=${lng}&type=${getType}`;
    url = connectSuffix('&', suffix, url);
    const response = await httpClient.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    if (error.response) {
      return error.response;
    }
  }
};

export const getLifeStyleScores = async (
  lat,
  lng,
  area = 'quarter-mile',
  email,
  suffix,
  isFree = false,
) => {
  try {
    let url = `${walkspan_api}${isFree ? '/public' : ''}/lifestyle-essentials/count/?areatype=${area}&lat=${lat}&lng=${lng}`;
    url = connectSuffix('&', suffix, url);

    const response = await httpClient.get(url);
    return response;
  } catch (error) {
    console.error(error);
    if (error.response) {
      return error.response;
    } else {
      console.error('An error occurred:', error.message);
      return { error: '50x' }; // General 50x error indicator
    }
  }
};

export const getRatings = async (
  lat,
  lng,
  area,
  email,
  suffix,
  isFree = false,
) => {
  try {
    let url = `${walkspan_api}${isFree ? '/public' : ''}/walkspan/get-ratings/?areatype=${area}&lat=${lat}&lng=${lng}`;
    url = connectSuffix('&', suffix, url);

    const response = await httpClient.get(url);
    return response;
  } catch (error) {
    console.error(error);
    if (error.response) {
      return error.response;
    } else {
      console.error('An error occurred:', error.message);
      return { error: '50x' }; // General 50x error indicator
    }
  }
};

export const getNeighborhoodScore = async (
  city = 'New York',
  state = 'NY',
  borough = '',
  email,
) => {
  try {
    const url = `${walkspan_api}/neighborhoods/all/?city=${city}&state=${state}&borough=${borough}`;
    const response = await httpClient.get(url);

    return response.data;
  } catch (error) {
    console.error(error);
    if (error.response && error.response.status === 401) {
    } else {
      return null;
    }
  }
};

export const fetchYelpRating = async (data) => {
  const { name, lat, lng, email } = data;
  const url = `${walkspan_api}/lifestyle-essentials/yelp-rating/?name=${name}&lat=${lat}&lng=${lng}`

  try {
    const response = await httpClient.get(url);
    return response.data?.Data?.[0];
  } catch (error) {
    console.error('Error fetching yelp rating:', error);
  }
}

export const fetchGoogleRating = async (data, email) => {
  const url = `${walkspan_api}/lifestyle-essentials/update-google-rating/?email=${email}`
  try {
    const response = await httpClient.post(url, data);
    return response;
  } catch (error) {
    console.error('Error fetching google rating:', error);
  }
}

export const logAPIKeyUsage = async (data) => {
  const url = `${walkspan_api}/users/log-api-key-usage/`
  try {
    const response = await httpClient.post(url, data);
    return response;
  } catch (error) {
    console.error('Error logging API Key', error);
  }
};

export const getPlaceByLatLng = async (latitude, longitude) => {
  const url = `${walkspan_api}/geoserver/geocode/latlng?latitude=${latitude}&longitude=${longitude}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    if (data && data.place_id) {
      return data;
    } else {
      console.error('Error fetching address:', data.status || 'Unknown Error');
    }
  } catch (error) {
    console.error('Error fetching address:', error);
  }
};

export const fetchPlaceId = async (place) => {
  const url = `${walkspan_api}/geoserver/geocode/place?address=${encodeURIComponent(place)}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data && data.place_id) {
      return data;
    } else {
      throw new Error('Place ID not found.');
    }
  } catch (error) {
    throw new Error('Error fetching place ID:', error);
  }
};

export const fetchPlaceDetails = async (placeId) => {
  return new Promise((resolve, reject) => {
    if (!window.google || !window.google.maps || !window.google.maps.Map) {
      reject(new Error('Google Maps API is not loaded.'));
      return;
    }

    const map = new window.google.maps.Map(document.createElement('div'));

    const service = new window.google.maps.places.PlacesService(map);
    service.getDetails(
      {
        placeId: placeId,
        fields: ['ALL'],
      },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          resolve(place);
        } else {
          reject(new Error('Place details request failed.'));
        }
      }
    );
  });
};

export const getNeighborhoodBounds = async (neighborhood, isFree = false) => {
  const url = `https://api.senseofwalk.com/api${isFree ? '/public' : ''}/neighborhoods/neighborhoods/williamsburg/?include_geojson=true`;
  try {
    const response = await httpClient.get(url);
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const getCityBounds = async (city, isFree = false) => {
  const url = `https://api.senseofwalk.com/api${isFree ? '/public' : ''}/neighborhoods/?city=${encodeURIComponent(city)}&include_geojson=true`;
  try {
    const response = await httpClient.get(url);
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const fetchNeighborhoodData = async () => {
  const response = await fetch(
    'https://services5.arcgis.com/GfwWNkhOj9bNBqoJ/arcgis/rest/services/Neighborhood_Names/FeatureServer/0/query?where=1=1&outFields=*&outSR=4326&f=pgeojson'
  );
  const data = await response.json();
  return data;
};

export const associateAgent = async (data) => {
  const url = `${walkspan_api}/subscriptions/associate-agent/`;
  try {
    const response = await httpClient.post(url, data);
    return response;
  } catch (error) {
    console.error('Error logging', error);
    return error;
  }
};

export const getProfileAnalytics = async (email, start_date, end_date) => {
  const url = `${walkspan_api}/analytics/agent-usage/searches_summary/?email=${encodeURIComponent(email)}&start_date=${start_date}&end_date=${end_date}`;
  try {
    const response = await httpClient.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};